import { Injectable } from '@angular/core';
import * as fromRoot from '@app/reducers';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { ListTeamUserTransfersOutput, Transfer } from '@smash-sdk/transfer/ejs/01-2024';
import { from, of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { Constant } from 'src/constant';
import { TransfersDeletedActions } from '../actions';



@Injectable()
export class TransfersDeletedEffects {

  loadTransfersDeleted$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TransfersDeletedActions.loadTransfersDeleted),
      withLatestFrom(
        this.store$.pipe(select(fromRoot.getActiveIdentity)),
        this.store$.pipe(select(fromRoot.getActiveTeam)),
      ),
      switchMap(([action, user, team]) => {
        if (team && team.id) {
          const transferSdk = new Transfer();
          const req = from(transferSdk.listTeamUserTransfers({ teamId: team.id, userId: user.id }));
          return req.pipe(
            map(({ transfers }) => {
              const sortedTransfers = [...transfers].sort((a, b) => new Date(b.created).getTime() - new Date(a.created).getTime()) as (ListTeamUserTransfersOutput['transfers'][0] & { team: string, receiversNumber: number, sender: string, receiverEmails: string, type: string })[];
              sortedTransfers.map(transfer => {
                transfer.transferDownloads = transfer.transferDownloads + transfer.filesDownloads;
                if (transfer?.delivery?.type) {
                  transfer.type = transfer.delivery.type;
                }
                if (transfer?.delivery?.sender?.email) {
                  transfer.sender = transfer.delivery.sender.email;
                }
                if (transfer?.delivery?.receivers) {
                  if (transfer.delivery.receivers.length === 1) {
                    transfer.receiverEmails = transfer.delivery.receivers[0];
                  } else if (transfer.delivery.receivers.length > 1) {
                    transfer.receiverEmails = `${transfer.delivery.receivers[0]} (+${transfer.delivery.receivers.length - 1})`;
                  }
                }
                transfer.receiversNumber = (transfer?.delivery?.receivers ? transfer.delivery.receivers.length : 0);
                return transfer;
              });
              const deletedTransfers = sortedTransfers.filter(transfer => transfer.status === Constant.transferStatus.Deleted || transfer.status === Constant.transferStatus.Deleting);
              return TransfersDeletedActions.loadTransfersDeletedSuccess({ transfers: deletedTransfers });
            }),
            catchError(error =>
              of(TransfersDeletedActions.loadTransfersDeletedFailure({ error: error.errorMessage }))
            )
          );
        } else {
          return of({ type: 'noop' });
        }
      })
    )
  );

  constructor(
    private actions$: Actions,
    private store$: Store<fromRoot.State>
  ) { }

}
